<template>
    <fb-form-body>
        <el-form :model="formData" :rules="rules" ref="form" label-width="100px" class="fb-form">
            <el-form-item label="名称" prop="name" :error="formErrorMsg.name" class="fb-form-item">
                <el-input v-model="formData.name"></el-input>
            </el-form-item>


            <el-form-item label="标识" prop="flag" class="fb-form-item">
                <el-input v-model="formData.flag"></el-input>
            </el-form-item>


            <el-form-item label="BANNER" prop="setting">

                <el-table
                        ref="tb"
                        :data="formData.setting"
                        border
                        style="width: 100%">
                    <el-table-column
                            prop="title"
                            label="标题"
                    >
                        <template slot-scope="scope">
                            <el-input v-model="scope.row.title"></el-input>
                        </template>
                    </el-table-column>
                    <el-table-column
                            prop="url"
                            label="跳转地址"
                    >
                        <template slot-scope="scope">
                            <el-input v-model="scope.row.url"></el-input>
                        </template>
                    </el-table-column>
                    <el-table-column
                            prop="bannerCode"
                            label="图片">
                        <template slot-scope="scope">

                            <div @click="handleChoosePicture(scope.row)" class="picture-box">
                                <span v-if="!scope.row.bannerUrl"><i class="el-icon-plus"></i>点击选择图片</span>
                                <img v-else :src="scope.row.bannerUrl" style="width: 100%;height: 100%"/>
                            </div>

                        </template>
                    </el-table-column>

                    <el-table-column
                            label="操作">
                        <template slot-scope="scope">
                            <el-link type="danger"
                                     @click="formData.setting.splice(formData.setting.indexOf(scope.row),1)"
                                     :underline="false" style="margin-left: 10px;">删除
                            </el-link>
                        </template>
                    </el-table-column>
                </el-table>

                <el-button size="mini" @click="handleAddBanner()" style="margin-top: 10px">新增</el-button>


            </el-form-item>



            <el-form-item>
                <el-button type="primary" @click="handleSubmit('form')">确定</el-button>
                <el-button @click="handleReset('form')">重置</el-button>
            </el-form-item>
        </el-form>
    </fb-form-body>
</template>

<script>
    import DictSelect from "../../components/DictSelect";
    export default {
        name: "RuleEdit",
        components: {DictSelect},
        data() {
            return {
                api:{
                   update:this.$api.bannerSetting.update,
                   detail:this.$api.bannerSetting.detail,
                },
                formErrorMsg:{
                    name: '',
                    flag: ''
                },
                formData: {
                    code:'',
                    name: '',
                    flag: '',
                    setting: []
                },
                rules: {
                    name: [
                        {required: true, message: '名称不能为空', trigger: 'blur'},
                    ],
                    flag: [
                        {required: true, message: '标识不能为空', trigger: 'blur'},
                    ]

                }
            }
        },
        methods: {
            handleChoosePicture(data) {
                let vm = this;
                let input = document.createElement("input");
                input.type = "file";
                input.onchange = function () {
                    data.bannerFile = input.files[0];
                    data.bannerUrl = URL.createObjectURL(input.files[0]);
                    vm.$set(vm.formData.setting,vm.formData.setting.indexOf(data),data);
                    vm.$forceUpdate();
                };
                input.click();

            },

            handleAddBanner() {
                this.formData.setting.push({title: '', url: '', bannerCode: '',bannerFile:''})
            },

            handleSubmit(form) {

                let vm = this;
                vm.$refs[form].validate((valid) => {
                    if (valid) {

                        let formData = new FormData();


                        for (let key in vm.formData){
                            if(key === 'setting'){
                                continue;
                            }
                            formData.append(key,vm.formData[key]);
                        }

                        vm.formData.setting.forEach((e,i)=>{
                            if(e.bannerFile) formData.append("banner_" + i,e.bannerFile);
                        });

                        formData.append("setting",JSON.stringify(vm.formData.setting));


                        vm.$http.post(vm.api.update,formData).then((resp)=>{

                            if(resp.data.status === 200){
                                vm.$message({
                                    type:'success',
                                    message: resp.data.desc
                                });
                                vm.$router.cgBack();
                            }else if(resp.data.status === 400){
                                resp.data.data.errorFields.forEach(function (a) {

                                    vm.formErrorMsg[a.name] = '';
                                    vm.$nextTick(() => {
                                        vm.formErrorMsg[a.name] = a.message;
                                    });


                                });
                                vm.$message({
                                    type:"error",
                                    message: resp.data.desc
                                });
                            }else{
                                vm.$message({
                                    type:"error",
                                    message: resp.data.desc
                                })
                            }

                        });
                        return true;
                    } else {
                        return false;
                    }
                });

            },
            handleReset(form) {
                this.$refs[form].resetFields();
            }
        },

        created() {

            let vm = this;
            this.$http.post(this.api.detail,this.$qs.stringify(this.$route.query)).then(function (resp) {
                for(let key in resp.data.data){
                    for(let fKey in vm.formData){
                        vm.formData[fKey] = resp.data.data[key][fKey]

                        if(fKey === 'setting' && vm.formData[fKey]){
                            vm.formData['setting'] = JSON.parse(resp.data.data[key][fKey]);
                            vm.formData['setting'].forEach((e)=>{
                                if(e.bannerCode){
                                    e.bannerUrl = (vm.$api.commonFile.download + "?code=" + e.bannerCode)
                                }
                            })
                        }

                    }
                }
            });

        }
    }
</script>

<style lang="scss" scoped>

    .fb-form-item {
        max-width: 500px;
    }

    .picture-box {
        width: 160px;
        height: 100px;
        line-height: 100px;
        text-align: center;
        display: inline-block;
        border: 2px dashed #f0f0f0;
        cursor: pointer;
    }

</style>
